"use strict";
/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
var en_1 = require("./en");
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./~/intl-relativeformat/lib/main.js
// module id = 672
// module chunks = 130